'use client';

import { useState, useRef, useEffect } from 'react';
import { VideoThoughtsCarouselCard } from '../video-thoughts-carousel-card/video-thoughts-carousel-card';
import { Button } from '../../../../../../../../libs/components/components';
import { cn } from '@shared/shared-utils';
import { AspectRatio } from '@shared/shared-shadcn-ui';
import ArrowRightIcon from '../../../../../../../../../public/svg/arrow-right.svg';
import { VIDEO_THOUGHTS } from '../constants';

const VideoThoughtsCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleCardClick = (index: number) => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    setActiveIndex(index);
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  }, [activeIndex]);

  return (
    <div className="w-full bg-ogn-blue border-2 border-ogn-blue rounded-[16px] max-w-[1225px]">
      <div className="w-full grid grid-cols-[162fr_83fr]">
        <AspectRatio className="w-full flex-grow" ratio={810 / 456}>
          <div className="w-full h-full bg-gray-400 rounded-tl-[16px] flex-shrink-0">
            <video
              ref={videoRef}
              src={VIDEO_THOUGHTS[activeIndex].src}
              poster={VIDEO_THOUGHTS[activeIndex].thumbnail}
              className="w-full h-full object-cover rounded-tl-[16px]"
              controls
              preload="metadata"
              key={activeIndex}
            />
          </div>
        </AspectRatio>
        <div className="p-6 flex flex-col gap-y-4">
          <h3
            key={activeIndex}
            className="text-[min(2.0vw,35px)] font-bold text-white animate-fade-in"
          >
            {VIDEO_THOUGHTS[activeIndex].caption}
          </h3>
          <Button
            onClick={() =>
              handleCardClick((activeIndex + 1) % VIDEO_THOUGHTS.length)
            }
            variant="white"
            className="text-nowrap lg:py-[15px] rounded-full lg:mt-12 leading-[100%] max-w-[230px] lg:px-[60px] inline-flex items-center gap-x-1 w-auto self-start lg:text-[min(1.3vw,25px)] font-roboto-condensed"
          >
            Next video{' '}
            <ArrowRightIcon className="w-[min(1vw,15px)] h-[min(1vw,15px)] flex-shrink-0" />
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-[repeat(auto-fit,_minmax(164px,1fr))]">
        {VIDEO_THOUGHTS.map((videoThought, index) => (
          <VideoThoughtsCarouselCard
            key={index}
            caption={videoThought.caption}
            preview={videoThought.preview}
            isActive={activeIndex === index}
            onClick={() => handleCardClick(index)}
            className={cn({
              'rounded-bl-[16px]': index === 0,
              'rounded-br-[16px]': index === VIDEO_THOUGHTS.length - 1,
            })}
          />
        ))}
      </div>
    </div>
  );
};

export { VideoThoughtsCarousel };
